"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = walkMarkdownTokens;

function walkMarkdownTokens(tokens, walker) {
  return tokens.map(function (token) {
    if (token) {
      var nextToken = walker(token);

      if (nextToken.children) {
        nextToken.children = walkMarkdownTokens(nextToken.children, walker);
      }

      return nextToken;
    }

    return token;
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9VdGlscy93YWxrTWFya2Rvd25Ub2tlbnMuanMiXSwibmFtZXMiOlsid2Fsa01hcmtkb3duVG9rZW5zIiwidG9rZW5zIiwid2Fsa2VyIiwibWFwIiwidG9rZW4iLCJuZXh0VG9rZW4iLCJjaGlsZHJlbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFlLFNBQVNBLGtCQUFULENBQTRCQyxNQUE1QixFQUFvQ0MsTUFBcEMsRUFBNEM7QUFDekQsU0FBT0QsTUFBTSxDQUFDRSxHQUFQLENBQVcsVUFBQUMsS0FBSyxFQUFJO0FBQ3pCLFFBQUlBLEtBQUosRUFBVztBQUNULFVBQU1DLFNBQVMsR0FBR0gsTUFBTSxDQUFDRSxLQUFELENBQXhCOztBQUVBLFVBQUlDLFNBQVMsQ0FBQ0MsUUFBZCxFQUF3QjtBQUN0QkQsUUFBQUEsU0FBUyxDQUFDQyxRQUFWLEdBQXFCTixrQkFBa0IsQ0FBQ0ssU0FBUyxDQUFDQyxRQUFYLEVBQXFCSixNQUFyQixDQUF2QztBQUNEOztBQUVELGFBQU9HLFNBQVA7QUFDRDs7QUFFRCxXQUFPRCxLQUFQO0FBQ0QsR0FaTSxDQUFQO0FBYUQiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHdhbGtNYXJrZG93blRva2Vucyh0b2tlbnMsIHdhbGtlcikge1xuICByZXR1cm4gdG9rZW5zLm1hcCh0b2tlbiA9PiB7XG4gICAgaWYgKHRva2VuKSB7XG4gICAgICBjb25zdCBuZXh0VG9rZW4gPSB3YWxrZXIodG9rZW4pO1xuXG4gICAgICBpZiAobmV4dFRva2VuLmNoaWxkcmVuKSB7XG4gICAgICAgIG5leHRUb2tlbi5jaGlsZHJlbiA9IHdhbGtNYXJrZG93blRva2VucyhuZXh0VG9rZW4uY2hpbGRyZW4sIHdhbGtlcik7XG4gICAgICB9XG5cbiAgICAgIHJldHVybiBuZXh0VG9rZW47XG4gICAgfVxuXG4gICAgcmV0dXJuIHRva2VuO1xuICB9KTtcbn1cbiJdfQ==